const config = {
  apiUrl: process.env.REACT_APP_API_URL || "https://natrajpaper.com",

  socketUrl: process.env.REACT_APP_SOCKET_URL || "https://natrajpaper.com",
};

export default config;
